//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goBack from '@/components/public-components/goBack/index.vue'
import mapList from '@/components/public-components/mapList/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"

export default {
    name: 'culture',
    components: {
        goBack,
        mapList,
        Footer
    },
    data() {
        return {
            showMapList: false,
            minHeight: 0,
            mapNav: { title: "123" },
            row: {
                
            }
        }    
    },
    watch: {
        '$route': function (to, from) {
        }
    },
    mounted() {
        this.minHeight = document.documentElement.clientHeight
        this.getRow().then(data => {
            document.title = data.news.title
            this.row = data
        })
    },
    methods: {
        getRow() {
            return new Promise((resolve, reject) => {
                this.$http.get(`api/wtcp-cms/public/news/${this.$route.query.id}`).then(res => {
                    resolve(res.data.data)
                })
            })
        },
        goPage(path) {
            this.$router.push({path})
        },
        phone(number) {
            window.location.href = 'tel:' + number
        }
    }
}
